// src/data/caracteristiques.js
import { faBuilding, faArrowsAltH, faCalendar, faStar, faLayerGroup, faChair, faShieldAlt, faWifi, faPlug, faSnowflake, faUsers, faCogs, faCar, faDoorOpen, faWindowRestore, faLightbulb, faPaintRoller, faUtensils, faLock, faChalkboardTeacher, faWheelchair, faRoad } from "@fortawesome/free-solid-svg-icons";

const caracteristiques = [
  { id: 1, name: "Immeuble indépendant", icon: faBuilding },
  { id: 3, name: "Année de construction : 2005", icon: faCalendar },
  { id: 31, name: "Accès personnes en situtaion d'handicap", icon: faWheelchair },
  { id: 21, name: "Rampe d'entrée", icon: faRoad },
  { id: 37, name: "Large porte", icon: faDoorOpen },
  { id: 4, name: "État du bien : Très bon état", icon: faStar },
  { id: 5, name: "Étage : 2", icon: faLayerGroup },
  { id: 6, name: "Salle de réunion", icon: faChalkboardTeacher },
  { id: 7, name: "Parking", icon: faCar },
  { id: 2, name: "Divisible", icon: faArrowsAltH },
  { id: 8, name: "Cloisons amovibles", icon: faDoorOpen },
  { id: 9, name: "Double vitrage", icon: faWindowRestore },
  { id: 10, name: "Faux plafond", icon: faChair },
  { id: 11, name: "Meublé", icon: faChair },
  { id: 12, name: "Chauffage : Pompe à chaleur", icon: faPlug },
  { id: 13, name: "Climatisation", icon: faSnowflake },
  { id: 14, name: "Alarme", icon: faShieldAlt },
  { id: 15, name: "Internet", icon: faWifi },
  { id: 16, name: "Câblage RJ45", icon: faPlug },
  { id: 17, name: "Fibre optique", icon: faLightbulb },
  { id: 18, name: "Salle de réunion partagée", icon: faUsers },
  { id: 19, name: "Wifi", icon: faWifi },
  { id: 20, name: "Espace d'attente", icon: faChair },
  { id: 22, name: "Domiciliation", icon: faBuilding },
  { id: 23, name: "Ménage des parties communes", icon: faCogs },
  { id: 24, name: "Tables / chaises", icon: faChair },
  { id: 25, name: "Salle de réunion privée", icon: faLock },
  { id: 26, name: "Disponibilité : Immédiate", icon: faStar },
  { id: 27, name: "Aménagement des bureaux : Cloisonnés", icon: faDoorOpen },
  { id: 28, name: "Aménagement des bureaux : Ouverts", icon: faWindowRestore },
  { id: 30, name: "Sanitaires : 3", icon: faLock },
  { id: 32, name: "Eclairage Bureaux : LED", icon: faLightbulb },
  { id: 33, name: "Plinthes techniques périphériques", icon: faCogs },
  { id: 34, name: "Sol bureaux : Moquette/Parquet", icon: faPaintRoller },
  { id: 35, name: "Sécurité : Contrôle d'accès", icon: faShieldAlt },
  { id: 36, name: "Restauration à proximité", icon: faUtensils },
];

export default caracteristiques;
